module.exports = __webpack_public_path__ + "img/ca.8678fc67.svg";